import React from "react";
import { RANGOS_RAPIDOS, describirRango, detectarRango } from "utils/rangosFecha";

// Selector de período para las tablas.
//
// Antes eran dos campos de fecha sueltos con un botón "Mes actual" pegado al
// lado, sin etiqueta, desalineado del resto de la fila. Para ver el mes pasado
// había que calcular las dos fechas y escribirlas a mano.
//
// La forma la copia de los filtros que esta misma pantalla ya tiene y que
// funcionan bien —"Tipo de documento", "Plazo del SII"—: una fila de chips
// donde el activo queda marcado. Los campos de fecha siguen abajo para el
// rango a medida, que es el caso menos frecuente.

const CHIP_BASE =
  "rounded-full border px-3 py-1 text-xs font-semibold transition whitespace-nowrap";
const CHIP_ACTIVO =
  "border-brand-600 bg-brand-600 text-white dark:border-brand-400 dark:bg-brand-400 dark:text-navy-900";
const CHIP_INACTIVO =
  "border-gray-300 bg-white text-navy-700 hover:bg-gray-50 dark:border-white/20 dark:bg-navy-800 dark:text-white dark:hover:bg-navy-700";

export default function FiltroRangoFechas({
  desde,
  hasta,
  onChange,
  titulo = "Período",
  etiquetaDesde = "Desde",
  etiquetaHasta = "Hasta",
  // Algunas pantallas no admiten "sin fechas" porque traerían el historial
  // completo en una sola consulta.
  permitirTodo = true,
}) {
  const activo = detectarRango(desde, hasta);
  const rangos = permitirTodo
    ? RANGOS_RAPIDOS
    : RANGOS_RAPIDOS.filter((r) => r.clave !== "todo");

  const aplicar = React.useCallback(
    (resolver) => {
      const r = resolver();
      onChange(r.desde, r.hasta);
    },
    [onChange],
  );

  return (
    <div className="flex flex-col gap-2">
      <div className="text-[11px] font-bold uppercase tracking-wide text-gray-500 dark:text-gray-400">
        {titulo}
      </div>

      <div className="flex flex-wrap gap-2">
        {rangos.map((rango) => (
          <button
            key={rango.clave}
            type="button"
            aria-pressed={activo === rango.clave}
            onClick={() => aplicar(rango.resolver)}
            className={`${CHIP_BASE} ${activo === rango.clave ? CHIP_ACTIVO : CHIP_INACTIVO}`}
          >
            {rango.etiqueta}
          </button>
        ))}
      </div>

      <div className="flex flex-wrap gap-3 items-end">
        <label className="flex flex-col gap-1 text-xs font-medium text-gray-600 dark:text-gray-300">
          {etiquetaDesde}
          <input
            type="date"
            value={desde || ""}
            max={hasta || undefined}
            onChange={(e) => onChange(e.target.value, hasta)}
            className="px-3 py-2 text-sm bg-white rounded-lg border border-gray-200 text-navy-800 dark:border-white/15 dark:bg-navy-800 dark:text-white"
          />
        </label>
        <label className="flex flex-col gap-1 text-xs font-medium text-gray-600 dark:text-gray-300">
          {etiquetaHasta}
          <input
            type="date"
            value={hasta || ""}
            min={desde || undefined}
            onChange={(e) => onChange(desde, e.target.value)}
            className="px-3 py-2 text-sm bg-white rounded-lg border border-gray-200 text-navy-800 dark:border-white/15 dark:bg-navy-800 dark:text-white"
          />
        </label>
        {/* Dos campos con fechas no dicen cuántos días se están mirando, y ese
            número es lo que se quiere saber al comparar un total con otro. */}
        <span className="pb-2 text-xs font-semibold text-gray-500 dark:text-gray-400">
          {describirRango(desde, hasta)}
        </span>
      </div>
    </div>
  );
}
